module.exports = __webpack_public_path__ + "050a26372760df5e3bb7a4c7cebd5c4a.svg";